import React from "react";
import PropTypes from "prop-types";
import _startCase from "lodash/startCase";
import "styles/grid-data.css";
import { Map } from "immutable";
import { formatCurrency } from "utilities/currency";

export default class GridData extends React.PureComponent {
    render() {
        return (
            // <Card className={"bg-primary"}>
            <div className={"grid-data"}>
                {this.props.data && new Map(this.props.data)
                    .map((value, label) => (
                        <React.Fragment key={label}>
                            <div key={label} className={"grid-item"}>
                                <div className={"grid-item-inner"}>
                                    <div
                                        style={{
                                            fontSize: "16px",
                                            fontWeight: 300,
                                            textAlign: "right"
                                        }}>
                                        {label == "throughput" ? "Disbursal Amount" :  _startCase(label)}
                                    </div>
                                    <div
                                        style={{
                                            fontSize: "20px",
                                            textAlign: "right"
                                        }}>
                                        {formatCurrency(value, true)}
                                    </div>
                                </div>
                            </div>
                        </React.Fragment>
                    ))
                    .toList()
                    .toArray()
                }
            </div>
            // </Card>
        );
    }
}

GridData.propTypes = {
    data: PropTypes.object,
    status: PropTypes.string
};
